import './../Filter/Filter.scss';
import Component from './TeamMemberListFilter.js';
export default Component;